// New version src/Common/controls/loader/loader.component.ts CommonLoaderComponent
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/controls/common_controls_loader_module/ctrl_loader_component_service.jsx CtrlLoaderComponent

import {
	Injector,
	Component,
	Input,
	SimpleChanges,
} from '@angular/core';
import {CommonBaseComponent} from '../../components/base.component';
import {COMMON_LOADER_DEFAULT_DELAY_TIMEOUT} from './loader_default_delay_timeout_constant';

@Component({
	selector: 'common-loader',
	templateUrl: './loader.component.pug',
	styleUrls: [
		'./loader.component.sass',
	],
})
export class CommonLoaderComponent extends CommonBaseComponent {
	@Input() isLoading = false;
	@Input() hasDelay = false;
	@Input() label = '';
	@Input() ctrlLoaderClasses = '';
	@Input() className = '';
	@Input() ctrlLoaderTopAligned = false;
	@Input() ctrlLoaderWithOverlay = false;

	isShow = false;
	protected loadTimeout = 0;
	protected cancelTimer: any;

	constructor (protected injector: Injector) {
		super(injector);
	}
	ngOnInit (): void {
		super.ngOnInit();

		this.willUnbind(() => {
			this.stopLoading();
		});
	}

	ngOnChanges (changes: SimpleChanges): void {
		super.ngOnChanges(changes);

		if (changes.hasDelay) {
			if (changes.hasDelay.currentValue) {
				this.loadTimeout = COMMON_LOADER_DEFAULT_DELAY_TIMEOUT;
			} else {
				this.loadTimeout = 0;
			}
		}

		if (changes.isLoading) {
			if (changes.isLoading.currentValue) {
				if (this.hasDelay) {
					this.startLoader();
				} else {
					this.isShow = true;
				}
			} else {
				if (this.hasDelay) {
					this.stopLoading();
				} else {
					this.isShow = false;
				}
			}
		}
	}

	protected startLoader (): void {
		this.cancelTimer = this.timeout(
			() => this.isShow = true,
			this.loadTimeout,
			(): null => this.cancelTimer = null,
		);
	}

	protected stopLoading (): void {
		if (this.cancelTimer) {
			this.cancelTimer();
		}

		this.isShow = false;
	}
}
